import { LoadingButton } from '@mui/lab';
import { Box, Button, DialogTitle, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useGetAddressInfo from 'api/address/useGetAddressInfo';
import SpinnerLoader from 'components/shared/SpinnerLoader/SpinnerLoader';
import { useSnackbar } from 'notistack';
import React, { useEffect, useRef } from 'react';

const ShowAddressModal = props => {
  const { guid, addressGuid, rootPrints, type } = props;
  const refElement = useRef(null);

  const [getAddressInfo, loading, addressInfo] = useGetAddressInfo();

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (props.show) {
      getAddressInfo({ addressGuid });
    }
  }, [props.show]);

  return (
    <Dialog
      open={props.show}
      onClose={props.closeHandler}
      sx={{ direction: 'rtl' }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle sx={{ boxShadow: '1', py: '10px' }}>مختصات آدرس</DialogTitle>

      <DialogContent
        sx={{
          padding: '40px 15px !important',
        }}
      >
        {loading ? (
          <SpinnerLoader />
        ) : !!addressInfo ? (
          <Box
            ref={refElement}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              direction: 'ltr',
            }}
          >
            <Typography sx={{ direction: 'rtl' }}>{addressInfo}</Typography>
          </Box>
        ) : null}
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3, py: '10px', boxShadow: '3' }}>
        <LoadingButton
          variant="contained"
          color="primary"
          onClick={() => {
            navigator?.clipboard?.writeText(addressInfo);
            enqueueSnackbar('آدرس کپی شد', { variant: 'info' });
          }}
        >
          کپی
        </LoadingButton>
        <LoadingButton
          variant="contained"
          color="warning"
          onClick={() => {
            // setPrintData(null);
            props.closeHandler();
          }}
        >
          بستن
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ShowAddressModal;
